var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5H8.61961L6.21724 9H3L3 5ZM7.38373 9L9.78611 5H13.2176L15.6201 9H15L14.9989 9L7.38373 9ZM16.7867 9H19L19.0013 9H21.1315L18.4648 5H14.3841L16.7867 9ZM14 10H3C2.44772 10 2 9.55228 2 9V5C2 4.44772 2.44772 4 3 4H18.4648C18.7992 4 19.1114 4.1671 19.2969 4.4453L21.9635 8.4453C22.4066 9.10986 21.9302 10 21.1315 10H20V20C20 20.5523 19.5523 21 19 21H15C14.4477 21 14 20.5523 14 20V10ZM19 10H15V12.7615L19 11.1615V10ZM19 16.7615L15 15.1615V13.8385L19 12.2385V16.7615ZM15 16.2385V20H19V17.8385L15 16.2385ZM6 13.55V11H7V13.5V14V14.5H6.5C5.67157 14.5 5 15.1716 5 16C5 16.8284 5.67157 17.5 6.5 17.5C7.32843 17.5 8 16.8284 8 16C8 15.7239 8.22386 15.5 8.5 15.5C8.77614 15.5 9 15.7239 9 16C9 17.3807 7.88071 18.5 6.5 18.5C5.11929 18.5 4 17.3807 4 16C4 14.7905 4.85888 13.7816 6 13.55Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.e5f7729868668e73eef5807e0bc25ab4.svg";
export { ForwardRef as ReactComponent };